import styled, { css } from 'styled-components';
import type { MenuPosition } from '../../../../types';
import { NutritionItem } from './NutritionItem';

interface NutritionProps {
  data?: MenuPosition;
}

export function Nutrition({ data }: NutritionProps) {
  const {
    nutritionCalories = '',
    nutritionCarbs = '',
    nutritionFat = '',
    nutritionProtein = ''
  } = data || {};

  return (
    [nutritionCalories, nutritionCarbs, nutritionFat, nutritionProtein].filter(
      (item) => item !== '' && item != null
    ).length > 0 && (
      <>
        <Divider />

        <Component>
          {[
            { nutritionCalories },
            { nutritionFat },
            { nutritionCarbs },
            { nutritionProtein }
          ].map((item, id) => (
            <StyledNutritionItem data={item} key={id} />
          ))}
        </Component>
      </>
    )
  );
}

const Component = styled.div`
  margin: 0 -10px -12px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  flex-wrap: wrap;
`;
const StyledNutritionItem = styled(NutritionItem)`
  min-width: 96px;
  margin: 0 10px 12px;
  ${({ theme: { windowWidth } }) =>
    windowWidth > 608 &&
    css`
      width: calc(25% - 20px);
    `};

  ${({ theme: { windowWidth } }) =>
    windowWidth <= 608 &&
    css`
      width: calc(50% - 20px);
    `};
`;
const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: rgba(17, 17, 17, 0.08);
  margin: 16px 0;
`;
